<template>
  <div></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { loadGLTF } from '../../Reusable/loadGLTF'
import { MeshBasicMaterial } from 'three'
export default {
  props: {
    url: {},
    name: {}
  },
  mixins: [O3DG2],
  data () {
    return {
    }
  },
  methods: {
    async setup () {
      this.gltf = await loadGLTF(this.url)
      this.gltf.scene.traverse((item) => {
        if (item.isMesh) {
          item.material = new MeshBasicMaterial({
            color: item.material.color,
            envMap: this.ctx.cubeCam.out.envMap
          })
          // this.ctx.cubeCam.add(item)
        }
      })
      this.o3d.add(this.gltf.scene)
      this.ctx.cubeCam.add(this.o3d)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>
</style>
